import makeTable from "./makeTable";
import BASE_WIDTH_COLUMNS from "./constants/baseWidthColumns";

const { DATE } = BASE_WIDTH_COLUMNS;

export enum ColumnId {
	CREATED_AT = "createdAt",
	TYPE = "type",
	SIMPLE_STATUS = "simpleStatus",

	TITLE = "title",
	TEXT = "text",
	COMPANY = "company",
	TAXI_SERVICE = "taxiService",
	MEDIA = "media",
}

export const translationTablePath =
	"pages.mainPage.pages.archives.tabs.pushHistory.content.";

export const allColumns: ColumnId[] = Object.values(ColumnId);

export const defaultColumns: ColumnId[] = allColumns;

const archivesPushHistory = makeTable({
	allIds: Object.values(ColumnId),
	i18tPath: (id) => `${translationTablePath}${id}`,
	defaultIds: defaultColumns,
	initialSortMethod: {
		column: ColumnId.CREATED_AT,
		type: "asc",
	},
	initialWidths: {
		[ColumnId.CREATED_AT]: DATE,
		[ColumnId.TYPE]: 150,
		[ColumnId.SIMPLE_STATUS]: 150,

		[ColumnId.TITLE]: 200,
		[ColumnId.TEXT]: 300,
		[ColumnId.MEDIA]: 150,
		[ColumnId.COMPANY]: 200,
		[ColumnId.TAXI_SERVICE]: 200,
	},
	initialResizable: Object.fromEntries(
		Object.values(ColumnId).map((id) => [id, true]),
	) as Record<ColumnId, boolean>,
	initialSortable: {
		[ColumnId.CREATED_AT]: true,
		[ColumnId.TYPE]: true,
		[ColumnId.SIMPLE_STATUS]: true,

		[ColumnId.TITLE]: true,
		[ColumnId.TEXT]: true,
		[ColumnId.MEDIA]: false,
		[ColumnId.COMPANY]: true,
		[ColumnId.TAXI_SERVICE]: true,
	},
});

export default archivesPushHistory;
